var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22600",
    "data-name": "Group 22600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.307,
    height: 19.16,
    viewBox: "0 0 19.307 19.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-icon-company"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3618",
    "data-name": "Rectangle 3618",
    width: 19.306,
    height: 19.161,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22599",
    "data-name": "Group 22599",
    clipPath: "url(#clip-path-icon-company)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12290",
    "data-name": "Path 12290",
    d: "M288.4,190.069l7.087,1.408a1.189,1.189,0,0,1,.957,1.174v8.205a1.205,1.205,0,0,1-1.207,1.207H288a.4.4,0,0,0,.4-.4v-.4h6.838a.4.4,0,0,0,.4-.4v-8.205a.4.4,0,0,0-.314-.394L288.4,190.89Z",
    transform: "translate(-277.14 -182.902)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12291",
    "data-name": "Path 12291",
    d: "M364.678,294.816a.4.4,0,1,1,0,.8h-1.609a.4.4,0,0,1,0-.8Z",
    transform: "translate(-348.992 -283.699)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12292",
    "data-name": "Path 12292",
    d: "M364.678,358.816a.4.4,0,1,1,0,.8h-1.609a.4.4,0,0,1,0-.8Z",
    transform: "translate(-348.992 -345.286)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12293",
    "data-name": "Path 12293",
    d: "M364.678,422.816a.4.4,0,1,1,0,.8h-1.609a.4.4,0,0,1,0-.8Z",
    transform: "translate(-348.992 -406.873)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12294",
    "data-name": "Path 12294",
    d: "M278.138,199.816a.4.4,0,1,1-.8,0V188.554a.428.428,0,0,1,.145-.314.423.423,0,0,1,.338-.08l.322.064v11.592Z",
    transform: "translate(-266.876 -181.057)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12295",
    "data-name": "Path 12295",
    d: "M205.481,486.816v.4a.4.4,0,0,0,.4.4h-3.218a.4.4,0,0,0,.4-.4v-.4Z",
    transform: "translate(-195.024 -468.459)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12296",
    "data-name": "Path 12296",
    d: "M172.678,102.816a.4.4,0,1,1,0,.8h-1.609a.4.4,0,0,1,0-.8Z",
    transform: "translate(-164.232 -98.939)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12297",
    "data-name": "Path 12297",
    d: "M173.08,167.217a.4.4,0,0,1-.4.4h-1.609a.4.4,0,1,1,0-.8h1.609a.4.4,0,0,1,.4.4",
    transform: "translate(-164.232 -160.525)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12298",
    "data-name": "Path 12298",
    d: "M172.678,230.816a.4.4,0,1,1,0,.8h-1.609a.4.4,0,0,1,0-.8Z",
    transform: "translate(-164.232 -222.113)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12299",
    "data-name": "Path 12299",
    d: "M172.678,294.816a.4.4,0,1,1,0,.8h-1.609a.4.4,0,0,1,0-.8Z",
    transform: "translate(-164.232 -283.699)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12300",
    "data-name": "Path 12300",
    d: "M66.413,295.217a.4.4,0,0,1-.4.4H64.4a.4.4,0,0,1,0-.8h1.609a.4.4,0,0,1,.4.4",
    transform: "translate(-61.587 -283.698)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12301",
    "data-name": "Path 12301",
    d: "M66.011,102.816a.4.4,0,1,1,0,.8H64.4a.4.4,0,0,1,0-.8Z",
    transform: "translate(-61.587 -98.939)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12302",
    "data-name": "Path 12302",
    d: "M66.011,166.816a.4.4,0,1,1,0,.8H64.4a.4.4,0,0,1,0-.8Z",
    transform: "translate(-61.587 -160.526)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12303",
    "data-name": "Path 12303",
    d: "M66.011,230.816a.4.4,0,1,1,0,.8H64.4a.4.4,0,0,1,0-.8Z",
    transform: "translate(-61.587 -222.113)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12304",
    "data-name": "Path 12304",
    d: "M89.355,360.023a.4.4,0,0,0-.4-.4H86.54a.4.4,0,0,0-.4.4v3.62h-.8v-3.62a1.2,1.2,0,0,1,1.207-1.207h2.413a1.2,1.2,0,0,1,1.207,1.207v3.62h-.8Z",
    transform: "translate(-82.115 -345.286)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12305",
    "data-name": "Path 12305",
    d: "M86.138,486.816h4.022v.4a.4.4,0,0,1-.4.4H85.736a.4.4,0,0,1-.4-.4v-.4Z",
    transform: "translate(-82.116 -468.459)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12306",
    "data-name": "Path 12306",
    d: "M1.408.016,10.248,1.36A1.2,1.2,0,0,1,11.262,2.55V7.168L10.94,7.1a.423.423,0,0,0-.338.08.428.428,0,0,0-.145.314V2.55a.407.407,0,0,0-.338-.4L1.279.813A.223.223,0,0,0,1.207.8.379.379,0,0,0,.949.9.385.385,0,0,0,.8,1.207V17.955a.4.4,0,0,0,.4.4H3.218v.4a.4.4,0,0,0,.4.4H1.207A1.205,1.205,0,0,1,0,17.955V1.207A1.185,1.185,0,0,1,.426.29,1.208,1.208,0,0,1,1.408.016",
    transform: "translate(0 -0.001)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon-company.183d1d535ec58fa763969c508a3dc12c.svg";
export { ForwardRef as ReactComponent };